import React from 'react';
import PropTypes from 'prop-types';
import Logger from 'observability/Logger';

import { WIDGET_URL_BY_ENV, ENV_PRODUCTION } from 'common/entities/formNode/eventOpsConstants';

const LOG = new Logger('EventOpsResources-WithEventOpsAutoLoad');

const loadScript = (url) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.defer = true;

    if (!__TESTING__) {
        document.body.appendChild(script);
    }
};

let loadStarted = false;

/**
 * @param {React} WrappedComponent
 * @return {React}
 */
export default function (WrappedComponent) {
    const WithEventOpsAutoLoad = (props) => {
        if (!loadStarted) {
            const url = WIDGET_URL_BY_ENV[props.widgetEnv];
            if (url === undefined) {
                LOG.error(`EventOPS widget error. Invalid URL ${url} for environment ${props.widgetEnv}`);
            } else {
                loadScript(url);
                loadStarted = true;
            }
        }
        return <WrappedComponent {...props} />;
    };

    WithEventOpsAutoLoad.propTypes = {
        widgetEnv: PropTypes.string,
    };
    WithEventOpsAutoLoad.defaultProps = {
        widgetEnv: ENV_PRODUCTION,
    };

    return WithEventOpsAutoLoad;
}

export const hasLoadStarted = () => loadStarted;
export const resetLoadStarted = () => {
    if (__TESTING__) {
        loadStarted = false;
    }
};
